export const WITHDRAWAL_METHOD_LABELS = {
  local_bank_transfer: "Local Bank Transfer",
  wafacash: "Wafacash",
  izi_payment: "Izi Payment",
  tunisia_post_mandat: "Tunisia Post Mandat",
  d17: "D17",
  flouci: "Flouci",
};

function isPlaceholder(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "" || normalized === "0" || normalized === "undefined";
}

function looksLikeNumericId(value) {
  const raw = String(value ?? "").trim();
  return raw !== "" && String(Number.parseInt(raw, 10)) === raw;
}

function displayValue(value, { skipNumericId = false } = {}) {
  if (isPlaceholder(value)) return "";
  if (skipNumericId && looksLikeNumericId(value)) return "";
  return String(value).trim();
}

function inferMethod(entity = {}) {
  const stored = String(entity.withdrawal_method || "").trim();
  if (WITHDRAWAL_METHOD_LABELS[stored]) return stored;
  if (
    !isPlaceholder(entity.bank_name) ||
    !isPlaceholder(entity.bank_account_number) ||
    !isPlaceholder(entity.bank_iban_number) ||
    !isPlaceholder(entity.bank_swift_number)
  ) {
    return "local_bank_transfer";
  }
  return "";
}

function pushRow(rows, label, value, options) {
  const shown = displayValue(value, options);
  if (!shown) return;
  rows.push({ label, value: shown });
}

export function payoutDetailRows(entity = {}) {
  const method = inferMethod(entity);
  const rows = [];
  if (WITHDRAWAL_METHOD_LABELS[method]) {
    rows.push({ label: "Withdrawal type", value: WITHDRAWAL_METHOD_LABELS[method] });
  }

  if (method === "d17" || method === "flouci") {
    pushRow(rows, "Recipient", entity.recipient_name);
    pushRow(rows, "Phone", entity.phone);
    return rows;
  }

  if (method === "wafacash" || method === "izi_payment" || method === "tunisia_post_mandat") {
    pushRow(rows, "Recipient", entity.recipient_name);
    pushRow(rows, "Phone", entity.phone);
    pushRow(rows, "ID / CIN", entity.id_number);
    pushRow(rows, "Country", entity.bank_country, { skipNumericId: true });
    pushRow(rows, "City", entity.bank_city, { skipNumericId: true });
    return rows;
  }

  pushRow(rows, "Bank name", entity.bank_name);
  pushRow(rows, "Account", entity.bank_account_number);
  pushRow(rows, "IBAN", entity.bank_iban_number);
  pushRow(rows, "SWIFT", entity.bank_swift_number);
  pushRow(rows, "City", entity.bank_city, { skipNumericId: true });
  pushRow(rows, "Country", entity.bank_country, { skipNumericId: true });
  pushRow(rows, "Bank details", entity.bank_details);
  return rows;
}
